import { Card, Col, message, Row } from 'antd';
import React, { Component } from 'react';
import DescriptionList from '@comm/DescriptionList';
import { BackBtn } from '@comm/BackBtn';
import { queryAnnouncementInfo } from '@api/administrative/announcement';

const { Description } = DescriptionList;

const typeName = ['公司公告', '业务动态'];
const categoryName = ['文档', '链接'];

class PageOpen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
    };
  }

  componentDidMount() {
    this.getAnnouncementInfo();
  }

  getAnnouncementInfo = () => {
    queryAnnouncementInfo({
      uuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { data } = this.state;
    return (
      <div className="form-open">
        <Row style={{ paddingBottom: '20px' }}>
          <Col span={13}>
            <BackBtn />
          </Col>
        </Row>
        <Card title="公告信息">
          <DescriptionList size="large" col={2}>
            <Description term="标题">{data.title}元</Description>
            <Description term="类型">{typeName[data.type]}</Description>
            <Description term="公告格式">{categoryName[data.category]}</Description>
            {data.category === 1 ? (
              <Description term="附件">
                <a
                  href={`http://preview.oa.vcchina.com/upload?url=${data.url}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {data.title}
                </a>
              </Description>
            ) : (
              <Description term="连接">
                <a href={`${data.url}`} target="_blank" rel="noreferrer">
                  {data.url}
                </a>
              </Description>
            )}
          </DescriptionList>
        </Card>
      </div>
    );
  }
}

export default PageOpen;



// WEBPACK FOOTER //
// ./src/components/administrative/announcement/PageOpen.js